module.exports = __webpack_public_path__ + "img/inspiration_collections.47be68b.jpg";